import Cookies from 'js-cookie';

class CookieToken<T> {
  payload: T;

  constructor(public cookieName: string) {
    this.payload = {} as T;
  }

  toString() {
    return Cookies.get(this.cookieName);
  }
}

export default CookieToken;
